// @flow @jsx h

import maxViewportObservable from '@nrk/max-viewport-observable'
import { format } from 'date-fns'
import { Component, h } from 'preact'
import style from './index.css'
import Content from './Content'
import Header from './Header'

import type { Props, State } from './types'

class Article extends Component<Props, State> {
  viewport$: any
  viewportSubscription: any

  constructor () {
    super()
    this.state = {
      muted: true,
      viewport: {
        width: -1,
        height: -1
      }
    }
  }

  componentDidMount () {
    this.viewport$ = maxViewportObservable.create({
      root: window
    })

    this.viewportSubscription = this.viewport$.subscribe({
      next: viewport => {
        this.setState({ viewport })
      }
    })
  }

  componentWillUnmount () {
    this.viewportSubscription.unsubscribe()
  }

  handleToggleMute = () => {
    this.setState({ muted: !this.state.muted })
  }

  render () {
    const { mediaBaseUrl, onAnalyticsEvent } = this.props
    const { publishedAt, sections } = this.props.data
    const { muted, viewport } = this.state

    return (
      <article className={style.article}>
        <Header {...this.props} viewport={viewport} />

        <Content
          mediaBaseUrl={mediaBaseUrl}
          muted={muted}
          onAnalyticsEvent={onAnalyticsEvent}
          onToggleMute={this.handleToggleMute}
          sections={sections}
          viewport={viewport}
        />

        <footer className={style.article__publishedAt}>
          Publisert {format(publishedAt, 'DD.MM.YYYY')}, kl.{' '}
          {format(publishedAt, 'HH:mm')}
        </footer>
      </article>
    )
  }
}

export default Article
